import { ReactNode } from 'react'

export enum PermissionType {
	Read = 'read',
	Write = 'write',
}

export interface NavItem {
	title: string
	url: string
	disabled?: boolean
	external?: boolean
	icon?: ReactNode
	label?: string
	description?: string
	isActive?: boolean
	items?: NavItem[]
	permissions?: string[]
	/**
	 * Key to identify which badge count to show (e.g., 'chatUnreadCount')
	 * The sidebar will look up this key from a badge counts context
	 */
	badgeKey?: string
}

export interface NavItemWithChildren extends NavItem {
	items: NavItemWithChildren[]
}

export interface NavItemWithOptionalChildren extends NavItem {
	items?: NavItemWithChildren[]
}

export interface FooterItem {
	title: string
	items: {
		title: string
		href: string
		external?: boolean
	}[]
}

export type MainNavItem = NavItemWithOptionalChildren

export type SidebarNavItem = NavItemWithChildren
